import { Alert, RefreshIcon } from '@exxonmobil/react-unity';
import React from 'react';
import styled from 'styled-components';

interface Props {
  message?: string;
  isRefreshable?: boolean;
  onRefresh: () => void;
}

export const ErrorBox = ({ message, onRefresh, isRefreshable = false }: Props) => {
  const errorMessage = message || 'Error: An error occurred while fetching the data.';
  return (
    <PureAlert variant="error">
      <ContentContainer>
        {errorMessage}
        {isRefreshable && <Icon data-testid="refresh" onClick={onRefresh} />}
      </ContentContainer>
    </PureAlert>
  );
};

const ContentContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
`;

const Icon = styled(RefreshIcon)`
  height: 18px;
  width: 18px;
`;

const PureAlert = styled(Alert)`
  margin: 16px;
`;
